<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uzAweT/tc-custom/9780802199317.jpg?1697122278473" alt="This image is the cover for the book Swimming in the Volcano"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Swimming in the Volcano
      </h1>
      <p class="bookDescription body article font2">
        <b>A vibrant portrait of love and politics in the tropics from the National Book Award–winning author: “the finest first novel I have read in many years” (William O’Rourke, <i>Chicago Tribune</i>).</b><br/>  <br/> Winner of the National Book Award for First Fiction for <i>Easy in the Islands</i>, Bob Shacochis returns to the islands with <i>Swimming in the Volcano</i>, a “splendid first novel” that illuminates the beauty and life of the Caribbean (<i>Library Journal</i>).<br/>  <br/> On the fictional island of St. Catherine, an American expatriate becomes unwittingly embroiled in an internecine war between rival factions of the government. Into this potentially explosive scene enters a woman he once loved and lost, but who remains a powerful temptation—one that proves impossible to resist.<br/>  <br/> Both an enchanting love story and a sophisticated political novel about the fruits of imperialism in the twentieth century, <i>Swimming in the Volcano</i> is as brutal and seductive a novel as the world it evokes.<br/>  <br/> “Scores of island people, from conspiring politicians to barbers on the beach, sprawl across the pages like oleander and hibiscus . . . each of [the book’s] scenes is expertly wrought.” —<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Shacochis
      </h2>
      
      <p class="authorDescription body article">A contributing editor for Outside and Harper's, Bob Shacochis has been a GQ columnist and writer for numerous other national publications. He is also the author of the novel, Swimming in the Volcano, a work of literary reportage about Haiti, The Immaculate Invasion, a second collection of stories, The Next New World, and a collection of essays on food and love, Domesticity. He lives in Florida and New Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f4094aa6